import { render } from "./DisplayText.vue?vue&type=template&id=a191854c&scoped=true"
import script from "./DisplayText.vue?vue&type=script&lang=js"
export * from "./DisplayText.vue?vue&type=script&lang=js"

import "./DisplayText.vue?vue&type=style&index=0&id=a191854c&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a191854c"]])

export default __exports__